import { Text } from '@sbab-ui/components'
import { ReactNode } from 'react'

interface Props {
  header: string
  children: ReactNode
  ['data-cy']?: string
}

function Table({ header, children, 'data-cy': dataCy }: Readonly<Props>) {
  return (
    <div data-cs-mask className="mb-4 flex flex-col" data-cy={dataCy}>
      <Text className="border-b !py-4 text-[32px]" as="h2">
        {header}
      </Text>
      {children}
    </div>
  )
}

export default Table
